<template>
  <div>
    <Modal title="学生课时" v-model="visible" width="1100">
      <Table class="compact" size="small" :columns="column" :data="dataList"></Table>
    </Modal>
  </div>
</template>
<script>
export default {
  name: 'UserClassHourModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data() {
    let $moment = this.$moment
    return {
      visible: this.value,
      dataList: [],
      totalNum: 0,
      totalConsumeNum: 0,
      totalLockNum: 0,
      column: [
        {
          title: '合计',
          width: 100,
          align: 'center',
          key: 'title'
        },
        {
          title: '课时数量',
          width: 100,
          align: 'center',
          key: 'num'
        },
        {
          title: '已消耗课时',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('span', { style: { color: 'red' } }, params.row.consumeNum)
          }
        },
        {
          title: '锁定课时(已选未上)',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('span', { style: { color: 'orange' } }, params.row.lockNum)
          }
        },
        {
          title: '剩余可用',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('span', { style: { color: 'green' } }, params.row.num - params.row.consumeNum - params.row.lockNum)
          }
        },
        {
          title: '课时类型',
          width: 135,
          align: 'center',
          key: 'type'
        },
        {
          title: '课时来源',
          width: 135,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.taskNum > 0) {
              return [
                h('span', row.channel + '（'),
                h('span', { style: { color: 'blue' } }, row.taskNum),
                h('span', '）')]
            }
            return row.channel
          }
        },
        {
          title: '生效时间',
          width: 135,
          align: 'center',
          key: 'gmtCreate'
        },
        {
          title: '有效期(天)',
          width: 135,
          align: 'center',
          key: 'effectDays'
        },
        {
          title: '到期时间',
          width: 135,
          align: 'center',
          key: 'expireTime'
        },
        {
          title: '操作人)',
          width: 135,
          align: 'center',
          key: 'creatorName'
        },
      ]
    }
  },
  methods: {
    onLoad () {
      let self = this
      self.$http.get('/class-hour/list', {params: {uid: self.uid}}).then(function (res) {
        if (!res || !res.data) {
          return
        }
        self.dataList = res.data
        self.dataList.forEach(function (item) {
          self.totalNum += item.num
          self.totalConsumeNum += item.consumeNum
          self.totalLockNum += item.lockNum
        })
        self.dataList.push({
          num: self.totalNum,
          consumeNum: self.totalConsumeNum,
          lockNum: self.totalLockNum,
          title: '合计',
        })
        self.visible = true
      })
    }
  },
  watch: {
    value(val) {
      if (val === true) {
        this.totalNum = 0
        this.totalConsumeNum = 0
        this.totalLockNum = 0
        this.onLoad()
      } else {
        this.visible = val
      }
    },
    visible(val) {
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// StudentClassHourModal.vue?550503a4